import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
// import FooterButton, { FooterButtonCenter } from "../../../components/FooterButton/FooterButton";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { Loading } from "../../../components/Loading/Loading";
import { useHistory } from "react-router-dom";
import { dataUserSession } from "../../../utilities/dataSession";
import { formatDateFile } from "../../../utilities/DateUtil";
import { DialogShow_2, DialogUpload } from "../../../components/DialogService/DialogService";

//SERVICE
import { P003GetData, P003CreateData, P003CreatePhotoData } from '../../../service/000/P003Service';
import { InputTextarea } from "primereact/inputtextarea";
import { commonUpload } from "../../../service/APP/AppService";
import { genGetBranchInfo } from "../../../service/GEN/GenService";
import Media from "../../../components/Media/Media";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { deCodeBase64 } from "../../../components/UploadPic/UploadPicUtil";

export default function P003() {
    const history = useHistory();
    const toast = useRef(null);

    const [showDialog, setShowDialog] = useState(false);
    const [textShow, setTextShow] = useState("");
    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);
    const [contractList, setContractList] = useState('');

    const [formObject, setFormObject] = useState({
        contractNo: "",
        profilePhotoPath: "",
        telephone: "",
        thumbnailPhotoPath: "",
        userId: "",
        userName: "",
        userPosition: "",
        userSurname: "",
        userType: "",
        userWorkunit: "",
    });
    const [searchData] = useState({
        "userId": dataUserSession() ? dataUserSession().userId : '',
    });

    const [dataFile, setDataFile] = useState(null);
    const [dialogUpload, setDialogUpload] = useState({ dialog: false, show: false });

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        }
    }, [history]);

    useEffect(() => {
        onP003GetData();
    }, [searchData]);

    const onP003GetData = () => {
        setLoading(true);
        P003GetData(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    let contractNoList  = '';
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        if(index===1){
                            contractNoList = element.contractNo && element.contractNo !== ''?element.contractNo:'';
                        }else{
                            contractNoList += element.contractNo && element.contractNo !== ''?' \n'+element.contractNo:'';
                        }
                        index++;

                    });
                    setFormObject(temp[0]);
                    setContractList(contractNoList)
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const [submitted, setSubmitted] = useState(false);

    const validation = (object) => {
        if (object.telephone === "") {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };

    const submitForm = () => {
        if (validation(formObject)) {

            P003CreateData(formObject).then(
                (res) => {
                    setLoading(false);

                    if (res.status === 200 && res.data[0]) {

                        if (res.data[0].statusText === '') {
                            if (res.data[0].statusCode === 'C') {
                                setTextShow(`บันทึกสมบูรณ์ `);
                            } else if (res.data[0].statusCode === 'E') {
                                setTextShow(`มีข้อผิดพลาด`);
                            }

                        } else {
                            setTextShow(`${res.data[0].statusText}`);
                        }
                        setShowDialog(true);

                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }

                    onP003GetData();
                },
                function (err) {
                    setLoading(false);
                    setErrData(err)
                }
            );
        }
    };

    const showMessages = (severity = "error", summary = "", detail = " ") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setFormObject({
            ...formObject,
            [`${key}`]: val,
        });
    };

    const onSaveFile = () => {

        let reqGen = {
            orderNo: "",
            requestNo: "U$" + searchData.userId,
            userId: searchData.userId
        }
        setLoading(true);
        genGetBranchInfo(reqGen).then(
            (res) => {
                setLoading(false);
                if (res && res.length > 0) {
                    onUpload(res[0]);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        )

        setDialogUpload({ dialog: false, show: false });
    };

    const onUpload = (dataObj) => {


        let req = {
            base64Pic: deCodeBase64(dataFile.fileUpload),
            picName: formatDateFile(new Date(), true) + "_" + searchData.userId,
            requestNo: "U$" + searchData.userId,
            userId: searchData.userId,
            branchId: dataObj.branchCode,
            fiscalYear: dataObj.fiscalYear,
            picType: dataFile.fileUpload.typefile
        };

        setLoading(true);
        commonUpload(req).then(
            (res) => {
                setLoading(false);
                if (res && res.status === 'Success') {
                    setDataFile({
                        ...dataFile,
                        picPath: res.picPath,
                        picUrl: res.picUrl
                    })

                    let newData = {
                        ...dataFile,
                        picPath: res.picPath,
                        picUrl: res.picUrl
                    }

                    onP003CreatePhotoData(newData)
                }

            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );

    }

    const onP003CreatePhotoData = (newData) => {

        let req = {
            profilePhotoPath: newData.picPath,
            thumbnailPhotoPath: newData.picPath,
            userId: searchData.userId
        }

        setLoading(true);
        P003CreatePhotoData(req).then(
            (res) => {
                setLoading(false);

                if (res.status === 200) {
                    if (res.data[0].statusText === '') {

                        if (res.data[0].statusCode === 'C') {
                            setTextShow(`บันทึกสมบูรณ์ `);
                        } else if (res.data[0].statusCode === 'E') {
                            setTextShow(`มีข้อผิดพลาด`);
                        }
                    } else {
                        setTextShow(`${res.data[0].statusText}`);
                    }
                    setShowDialog(true);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
                onP003GetData();
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );

    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-6">
                                <div className="p-grid" style={{ textAlign: "center" }}>
                                    <div className="p-col-12">
                                        <Media
                                            path={formObject.profilePhotoPath}
                                            alt={formObject.userName}
                                            // type = "video"
                                            typefile="person"
                                        />

                                    </div>
                                    <div className="p-col-12">
                                        <Button
                                            className="p-button-success p-button p-md-12 "
                                            icon="pi pi-image"
                                            label="เพิ่มรูปถ่าย"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 200, marginLeft: "5px", marginTop: '10px' }}
                                            // onClick={() => setShowAdvance(!showAdvance)}
                                            onClick={() => setDialogUpload({ dialog: true, show: true })}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-5">
                                <div className="p-grid  p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        <label>รหัสผู้ใช้งาน</label>
                                        <div className="p-inputgroup">
                                            <InputText
                                                id="userId"
                                                placeholder="รหัสผู้ใช้งาน"
                                                // disabled={true}
                                                disabled
                                                type="text"
                                                // onChange={(e) => onInputTextChange(e, "TITLE_ID")} />
                                                value={formObject.userId}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>

                                    <div className="p-col-12 p-md-6">
                                        <label>ชื่อ</label>
                                        <div className="p-inputgroup">
                                            <InputText placeholder="ชื่อ"
                                                id="userName"
                                                type="text"
                                                disabled
                                                value={formObject.userName}
                                            />
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label>นามสกุล</label>
                                        <div className="p-inputgroup">
                                            <InputText placeholder="นามสกุล"
                                                id="userSurname"
                                                type="text"
                                                disabled
                                                value={formObject.userSurname} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>

                                    <div className="p-col-12 p-md-6">
                                        <label>ประเภทผู้ใช้งาน</label>
                                        <div className="p-inputgroup">
                                            <InputText placeholder="ประเภทผู้ใช้งาน"
                                                disabled={true}
                                                id="userType"
                                                type="text"
                                                disabled
                                                value={formObject.userType} />
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label>สังกัดหน่วยงานบริษัทคู่สัญญา</label>
                                        <div className="p-inputgroup">
                                            <InputText placeholder="สังกัดหน่วยงานบริษัทคู่สัญญา"
                                                id="userWorkunit"
                                                type="text"
                                                disabled
                                                value={formObject.userWorkunit} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6 p-invalid">
                                        <label>เบอร์ติดต่อ</label>
                                        <span style={{ color: "red" }}>*</span>
                                        <div className="p-inputgroup">
                                            <InputText
                                                className="p-invalid"
                                                placeholder="เบอร์ติดต่อ"
                                                id="telephone"
                                                type="text"
                                                value={formObject.telephone}
                                                onChange={(e) => onInputTextChange(e, "telephone")}
                                            />
                                        </div>
                                        {submitted && !formObject.telephone && validateInputText("telephone", "เบอร์ติดต่อ")}
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label>ตำเเหน่ง</label>
                                        <div className="p-inputgroup">
                                            <InputText placeholder="ตำเเหน่ง"
                                                id="userPosition"
                                                type="text"
                                                disabled
                                                value={formObject.userPosition} />
                                        </div>
                                    </div>
                                </div>

                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-12">
                                        <label>เลขที่สัญญา</label>
                                        <div className="p-inputgroup">
                                            <InputTextarea
                                                value={contractList}
                                                disabled
                                                rows={5} cols={30} 
                                                autoResize
                                            />

                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="p-col-12 p-md-1"></div>
                            <div className="p-col-12 p-md-12">
                                <div style={{ height: "20px" }} />
                                <div className="p-grid" style={{ textAlign: "center" }}>
                                    <div className="p-col-12">
                                        <Button
                                            className="p-button-success"
                                            icon="pi pi-save"
                                            label="บันทึก"
                                            style={{ width: 150, marginTop: '10px' }}
                                            onClick={() => submitForm()}
                                        />
                                        <Button
                                            className="p-button-danger p-button"
                                            icon="pi pi-times"
                                            label="ปิดหน้าจอ"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 150, marginLeft: "5px", marginTop: '10px' }}
                                            onClick={() => { history.push('/') }}
                                        />

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <DialogUpload
                    dialog={dialogUpload}
                    setDialog={setDialogUpload}
                    dataFile={dataFile}
                    setDataFile={setDataFile}
                    onSaveFile={onSaveFile}
                // typeFile =".jpg"
                />

                <DialogShow_2 visible={showDialog} header="แจ้งเตือน" modal
                    onHide={() => setShowDialog(false)} className="p-fluid" textContent={textShow}
                    btnCancle={() => setShowDialog(false)} />

            </div>
        </>
    );
}
